import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Caption, LabelM } from '@sorare/core/src/atoms/typography';

import {
  CardAvatar as BaseCardAvatar,
  smallCardAvatarWidth,
} from 'components/cards/Avatar';
import { PlayerAvatar as BasePlayerAvatar } from 'components/player/Avatar';

export const Wrapper = styled(Vertical).attrs({ gap: 2 })``;

export const Competition = styled(Horizontal).attrs({ gap: 2 })``;

export const LineupGameList = styled(Vertical)`
  padding: var(--unit);
  margin-left: 60px;
`;

export const CardAvatar = styled(BaseCardAvatar).attrs({
  maxWidth: smallCardAvatarWidth,
})`
  width: 100px;
  border-radius: var(--double-unit);
  border: 1px solid var(--c-neutral-300);
  overflow: hidden;
`;

export const CardAvatarSmall = styled(CardAvatar)`
  width: 60px;
`;

export const PlayerAvatar = styled(BasePlayerAvatar)`
  width: 100px;
  border-radius: var(--double-unit);
  border: 1px solid var(--c-neutral-300);
  overflow: hidden;
`;

export const PlayerBlock = styled(Horizontal).attrs({ gap: 2 })``;

export const LineupPlayerBlock = styled(PlayerBlock).attrs({
  as: 'button',
  type: 'button',
})`
  &:hover {
    cursor: pointer;
    background-color: var(--c-neutral-300);
  }
  width: 100%;
  text-align: left;
`;

export const PlayerTeamLink = styled(Link)`
  font: var(--t-14);
  line-height: 130%;
  color: var(--c-neutral-600);
`;
export const PlayerNameAndTeam = styled(Vertical).attrs({ gap: 0.5 })`
  margin-right: auto;
`;

export const CardBonus = styled(Caption)`
  background: var(--c-neutral-300);
`;

export const RankAndScore = styled(Vertical).attrs({ gap: 0 })`
  margin-left: auto;
  align-items: flex-end;
`;

export const Score = styled(LabelM)`
  color: var(--c-neutral-600);
`;
